<template>
    <div class="faq-container">
        <div style="color: #f8f9fa; font-size: 1px;">1</div>
        <div class="content-wrapper">
            <SimpleHeader title="常見問題解答" subtitle="快速找到您需要的解決方案" />

            <div class="collapse-wrapper">
                <el-collapse v-model="activeName" accordion>
                    <el-collapse-item 
                        v-for="(item, index) in faqList" 
                        :key="index" 
                        :name="String(index + 1)"
                        class="collapse-item">
                        <template #title>
                            <div class="collapse-header">
                                <span class="prefix">Q{{ index + 1 }}</span>
                                {{ item.question }}
                            </div>
                        </template>
                        <div class="collapse-content">
                            <div class="content-point">
                                <i class="bi bi-dot"></i>
                                {{ item.answer }}
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>

            <div class="contact-reminder" data-aos="fade-up">
                <div class="reminder-content">
                    <i class="bi bi-telephone"></i>
                    <div class="text-group">
                        <p>需要更多幫助？立即聯繫我們的支持團隊</p>
                        <h3>{{ phoen }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            activeName: '1',
            phoen: '',
            faqList: []
        }
    },
    mounted() {
        this.GetcommonList()
        this.GetPersonalInformationList()
    },
    methods: {
        GetcommonList() {
            this.$axios.get(`/common/list?page=1&perPage=100000`)
                .then(res => {
                    this.faqList = res.data.data.items.reverse().map(item => ({
                        question: item.question,
                        answer: item.answer
                    }));
                })
                .catch(console.error)
        },
        GetPersonalInformationList() {
            this.$axios.get(`/personalInformation/list?page=1&perPage=100000`)
                .then(res => {
                    this.phoen = res.data.data.items[0]?.phone || ''
                })
                .catch(console.error)
        }
    }
}
</script>

<style scoped>
.faq-container {
    background: #f8f9fa;
    padding: 4rem 0;
}

.content-wrapper {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1.5rem;
}

.collapse-wrapper {
    margin: 4rem 0;
}

::v-deep(.el-collapse) {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(5, 42, 92, 0.06);
    border: none;
}

::v-deep(.el-collapse-item) {
    margin-bottom: 1px;
}

::v-deep(.el-collapse-item__header) {
    height: auto !important;
    padding: 1.8rem 2rem;
    font-size: 1.2rem;
    color: #1a2943;
    background: #ffffff;
    border-bottom: 1px solid #e4e7ed;
    transition: all 0.2s ease;
}

::v-deep(.el-collapse-item__header:hover) {
    background: #f8fbff;
}

::v-deep(.el-collapse-item.is-active) .el-collapse-item__header {
    color: #0052ff;
    border-left: 4px solid #0052ff;
    padding-left: 1.8rem;
}

::v-deep(.el-collapse-item__content) {
    padding: 2rem 3.5rem;
    background: #f8fbff;
    border: none;
}

.collapse-header {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    font-weight: 500;
}

.prefix {
    color: #0052ff;
    font-weight: 700;
    min-width: 3.5rem;
}

.collapse-content {
    font-size: 1.1rem;
    color: #4d5a6d;
    line-height: 1.8;
}

.content-point {
    display: flex;
    align-items: flex-start;
    gap: 0.8rem;
    margin-bottom: 1rem;
}

.content-point i {
    color: #0052ff;
    font-size: 1.4rem;
    margin-top: 0.3rem;
}

.contact-reminder {
    margin: 6rem 0;
    background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
    border-radius: 16px;
    padding: 2rem;
}

.reminder-content {
    display: inline-flex;
    align-items: center;
    gap: 1.5rem;
    background: white;
    padding: 2rem 3rem;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 82, 255, 0.08);
    width: 100%;
    max-width: 600px;
}

.reminder-content i {
    font-size: 2.5rem;
    color: #0052ff;
    flex-shrink: 0;
}

.text-group p {
    color: #6c757d;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
}

.text-group h3 {
    color: #1a2943;
    font-size: 1.6rem;
    margin: 0;
}

@media (max-width: 768px) {
    .faq-container {
        padding: 2rem 0;
    }
    
    .content-wrapper {
        padding: 0 1rem;
    }

    ::v-deep(.el-collapse-item__header) {
        padding: 1.2rem;
        font-size: 1rem;
    }

    .prefix {
        min-width: 2.5rem;
    }

    .reminder-content {
        flex-direction: column;
        text-align: center;
        padding: 1.5rem;
    }

    .text-group h3 {
        font-size: 1.4rem;
    }
}
</style>